import React from 'react';
import SEOHead from '../../components/seo/SEOHead';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <>
      <SEOHead
        title="Terms of Service"
        description="Read our terms of service to understand the rules and guidelines for using Animatronic Database."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-content-primary mb-8">Terms of Service</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-content-secondary">Effective Date: 01/13/2025</p>

            Welcome to Animatronic Database, operated by Big Leaf LLC. By using our website, you agree to these Terms of Service ("Terms").
            
            <section>
              <h2>1. Use of the Site</h2>
              <p>You agree to:</p>
               <ul>
                <li>Use the site only for lawful purposes.</li>
                <li>Refrain from uploading harmful, abusive, or infringing content.</li>
                <li>Respect other users and the community.</li>
              </ul>
            </section>

            <section>
              <h2>2. User Accounts</h2>
              <ul>
                <li>Account creation requires authentication via Auth0.</li>
                <li>You are responsible for maintaining the confidentiality of your account.</li>
                <li>Content you upload must be your own or properly attributed to its creator.</li>
              </ul>
            </section>

            <section>
              <h2>3. Content Approval</h2>
              <p>All submitted content (e.g., images, descriptions) will be reviewed and approved by Animatronic Database before publication.</p>
            </section>
            <section>
              <h2>4. Sponsored Content and Merchandise</h2>
              <p>We may offer sponsorship opportunities and a merchandise store. Additional terms may apply.</p>
            </section>

            <section>
              <h2>5. Limitation of Liability</h2>
              <p>
               Animatronic Database is not responsible for inaccuracies, errors, or user-generated content.
              </p>
            </section>

            <section>
              <h2>6. Jurisdiction</h2>
              <p>
                These Terms are governed by the laws of the state of Georgia, USA.
              </p>
            </section>

            <section>
              <h2>7. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of the website
                after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2>7. Contact</h2>
              <p>
                For questions about these terms, please contact{' '}
                <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
                  legal@animatronicdatabase.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default TermsOfService;